import { Button } from '@/components/ui/button';

const ErrorFallback = () => (
  <div className="flex min-h-screen items-center justify-center">
    <div className="text-center">
      <h1 className="font-bold text-2xl">Eitthvað fór úrskeiðis</h1>
      <p className="mt-2 text-muted-foreground">Eitthvað fór úrskeiðis. Vinsamlegast reyndu að endurhlaða síðunni.</p>
      <Button className="mt-4" onClick={() => window.location.reload()}>
        Endurhlaða síðunni
      </Button>
    </div>
  </div>
);

export default ErrorFallback;
